import { QueryRuleView } from './view';
import { QueryRuleEdit } from './edit';

export const QueryRule = ({
  data = {},
  index = 0,
  properties = [],
  mode = '',
  onChange = () => {},
  onDelete = () => {}
}) => {
  const is_edit_mode = mode === 'edit';

  if (!is_edit_mode) {
    return <QueryRuleView data={data} properties={properties} />;
  }

  return (
    <QueryRuleEdit
      data={data}
      index={index}
      properties={properties}
      onChange={onChange}
      onDelete={onDelete}
    />
  );
};
